import { render, staticRenderFns } from "./SocialAuthBox.vue?vue&type=template&id=50e0c148&scoped=true"
import script from "./SocialAuthBox.vue?vue&type=script&lang=js"
export * from "./SocialAuthBox.vue?vue&type=script&lang=js"
import style0 from "./SocialAuthBox.vue?vue&type=style&index=0&id=50e0c148&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e0c148",
  null
  
)

export default component.exports